import { useQuery } from '@apollo/client';
import { READ_VERIFIED_EXTERNAL_ATTRIBUTE } from 'graphql/queries/readVerifiedExternalAttribute';
import { useAuthStore } from 'stores/authStore';
import {
  ExternalVerificationType,
  Query,
  QueryReadVerifiedExternalAttributeArgs,
} from 'types/generatedSchemaTypes';

interface UseEmailVerifiedByOtherProps {
  email: string;
  customerUid: string;
}

export const useEmailVerifiedByOther = ({
  email,
  customerUid,
}: UseEmailVerifiedByOtherProps) => {
  const token = useAuthStore((state) => state.accessToken);

  const { data, loading } = useQuery<
    Pick<Query, 'readVerifiedExternalAttribute'>,
    QueryReadVerifiedExternalAttributeArgs
  >(READ_VERIFIED_EXTERNAL_ATTRIBUTE, {
    variables: {
      email: email!,
      externalVerificationType: 'EMAIL' as ExternalVerificationType,
    },
    skip: !token || !email,
    fetchPolicy: 'cache-first',
  });

  const attribute = data?.readVerifiedExternalAttribute;
  const isVerifiedByOther =
    !!attribute &&
    attribute.status === 'VERIFIED' &&
    !!customerUid &&
    attribute.customerUid !== customerUid;

  return {
    isVerifiedByOther,
    verifiedByOtherEmail: isVerifiedByOther ? email : undefined,
    loading,
  };
};
